export default {
  contactMail: "kontakt@stolicaexperymentu.edu.pl",
  description: 512,
  price: 4,
  count: 2,
  capacity: 3,
};
